import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { Slider } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  Slider,
  React
};